import { useBoostedFarmUserInfos } from 'hooks/boost-farm/useBoostedFarmUserInfos'
import { useMemo } from 'react'

const useIsNftsStaking = () => {
  const { data: boostedFarmUserInfos, isLoading: isBoostedFarmUserInfosLoading } = useBoostedFarmUserInfos()

  const isNftsStaking = useMemo(() => {
    return (
      !isBoostedFarmUserInfosLoading &&
      boostedFarmUserInfos.some((boostedFarmDetails) => boostedFarmDetails.userInfo[2].length > 0)
    )
  }, [boostedFarmUserInfos, isBoostedFarmUserInfosLoading])

  return {
    isNftsStaking,
    isLoading: isBoostedFarmUserInfosLoading,
  }
}

export default useIsNftsStaking
